/**
 * Enum containing the registrable events used in the KeepTrack API.
 */
export var EventBusEvent;
(function (EventBusEvent) {
    EventBusEvent["onHelpMenuClick"] = "onHelpMenuClick";
    /**
     * Run at the end of SelectSatManager.selectSat with parameters (sat: SatObject, satId: number)
     */
    EventBusEvent["selectSatData"] = "selectSatData";
    /**
     * Run at the end of catalogManager.setSecondarySat with parameters (sat: SatObject, satId: number)
     */
    EventBusEvent["setSecondarySat"] = "setSecondarySat";
    EventBusEvent["onKeepTrackReady"] = "onKeepTrackReady";
    EventBusEvent["updateSelectBox"] = "updateSelectBox";
    EventBusEvent["onCruncherReady"] = "onCruncherReady";
    EventBusEvent["onCruncherMessage"] = "onCruncherMessage";
    EventBusEvent["uiManagerInit"] = "uiManagerInit";
    EventBusEvent["uiManagerOnReady"] = "uiManagerOnReady";
    EventBusEvent["bottomMenuClick"] = "bottomMenuClick";
    EventBusEvent["hideSideMenus"] = "hideSideMenus";
    EventBusEvent["orbitManagerInit"] = "orbitManagerInit";
    EventBusEvent["drawManagerLoadScene"] = "drawManagerLoadScene";
    EventBusEvent["drawOptionalScenery"] = "drawOptionalScenery";
    EventBusEvent["updateLoop"] = "updateLoop";
    /**
     * Run as the default case in the rmbMenuActions event with parameters (targetId: string, clickedSat: number)
     */
    EventBusEvent["rmbMenuActions"] = "rmbMenuActions";
    /**
     * Runs during inputManager.init immediately before adding the clear lines and clear screen buttons
     */
    EventBusEvent["rightBtnMenuAdd"] = "rightBtnMenuAdd";
    EventBusEvent["updateDateTime"] = "updateDateTime";
    EventBusEvent["propRateChanged"] = "propRateChanged";
    EventBusEvent["uiManagerFinal"] = "uiManagerFinal";
    EventBusEvent["resetSensor"] = "resetSensor";
    /**
     * Run in the setSensor method of SensorManager instance with parameters (sensor: DetailedSensor | string, staticId: number)
     */
    EventBusEvent["setSensor"] = "setSensor";
    EventBusEvent["changeSensorMarkers"] = "changeSensorMarkers";
    EventBusEvent["resize"] = "resize";
    EventBusEvent["altCanvasResize"] = "altCanvasResize";
    EventBusEvent["endOfDraw"] = "endOfDraw";
    /**
     * Run in the updateWatchlist method of CatalogManager instance with parameters (watchlist: number[])
     */
    EventBusEvent["onWatchlistUpdated"] = "onWatchlistUpdated";
    EventBusEvent["onWatchlistAdd"] = "onWatchlistAdd";
    EventBusEvent["onWatchlistRemove"] = "onWatchlistRemove";
    /**
     * Run in the staticOffset setter of TimeManager instance with parameters (staticOffset: number)
     */
    EventBusEvent["staticOffsetChange"] = "staticOffsetChange";
    /**
     * Runs when a line is added to the line manager
     */
    EventBusEvent["onLineAdded"] = "onLineAdded";
    /**
     * Runs when a sensor dot is selected but not when a sensor is selected from the sensor menu
     */
    EventBusEvent["sensorDotSelected"] = "sensorDotSelected";
    EventBusEvent["canvasMouseDown"] = "canvasMouseDown";
    EventBusEvent["touchStart"] = "touchStart";
    EventBusEvent["ConeMeshUpdate"] = "ConeMeshUpdate";
    EventBusEvent["bottomMenuModeChange"] = "bottomMenuModeChange";
    EventBusEvent["saveSettings"] = "saveSettings";
    EventBusEvent["loadSettings"] = "loadSettings";
    EventBusEvent["update"] = "update";
    EventBusEvent["parseGetVariables"] = "parseGetVariables";
    EventBusEvent["rightBtnMenuOpen"] = "rightBtnMenuOpen";
    EventBusEvent["searchUpdated"] = "searchUpdated";
    EventBusEvent["layerUpdated"] = "legendUpdated";
    EventBusEvent["satInfoBoxAddListeners"] = "satInfoBoxAddListeners";
    EventBusEvent["satInfoBoxInit"] = "satInfoBoxInit";
    EventBusEvent["satInfoBoxFinal"] = "satInfoBoxFinal";
    EventBusEvent["error"] = "error";
    EventBusEvent["userAccountChange"] = "userAccountChange";
    EventBusEvent["userLogin"] = "userSignedIn";
    EventBusEvent["userLogout"] = "userLogout";
    EventBusEvent["KeyUp"] = "inputEvent:keyup";
    EventBusEvent["KeyDown"] = "inputEvent:keydown";
    EventBusEvent["KeyPress"] = "inputEvent:keypress";
    EventBusEvent["SceneReady"] = "SceneReady";
    EventBusEvent["highPerformanceRender"] = "highPerformanceRender";
    EventBusEvent["onLinesCleared"] = "onLinesCleared";
    EventBusEvent["selectedDateChange"] = "selectedDateChange";
    EventBusEvent["calculateSimulationTime"] = "calculateSimulationTime";
})(EventBusEvent || (EventBusEvent = {}));
